export default __webpack_public_path__ + "static/media/Raider's Gloves of the Ritual Flame.aade79c6.jpg";